import TyumenOurHomeBigWidgetIcon from './component'

export default TyumenOurHomeBigWidgetIcon
